"use strict";

var LoggerInstance = require("js-logger").get("EventSearchApi");

var AbstractApi = require("./AbstractApi");

var ApiHelper = require("../shared/ApiHelper");

var EventSearchApi = class extends AbstractApi {
	search(options) {
		options = options || {};
		return this.get({
			// explicitly mapping options for visibility
			queryString: ApiHelper.deleteUndefinedValues({
				country: options.country,
				distance: options.distance,
				eventTypes: options.eventTypes,
				id: options.id,
				isDistanceInKilometers: options.isDistanceInKilometers,
				layoutId: options.layoutId,
				layoutName: options.layoutName,
				limit: options.limit,
				offset: options.offset,
				postalCode: options.postalCode,
				searchId: options.searchId,
				state: options.state
			}, /* includeNulls */ true),
			url: `/api/eventsearchby${options.searchType}/getresults`
		});
	}
};

module.exports = new EventSearchApi();
